module.exports = __webpack_public_path__ + "images/external_images/svg/icons/047-web design.svg";